<template>
  <el-dialog title="新建/编辑" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="分组名称" prop="title">
        <el-input v-model="form.title" placeholder="请输入折扣分组" />
      </el-form-item>
      <el-form-item label="下单折扣" prop="buyRatio">
        <el-input v-model="form.buyRatio" placeholder="请输入折扣">
          <i slot="suffix" class="el-input__icon">折</i>
        </el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.description" placeholder="请输入描述" />
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysProfitRatioApi from '@/api/sys/sysProfitRatio'

function initFormBean() {
  const formBean = {
    title: null,
    buyRatio: null,
    description: null,
    isEnable: false
  }
  return formBean
}

export default {
  name: 'UserAdd',
  data() {
    return {
      options: {
        sysDept: [],
        sysRole: []
      },
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: '请输入折扣分组', trigger: 'blur' }],
        buyRatio: [{ required: true, message: '请输入折扣', trigger: 'blur' },
        { pattern: /^(?:[01]|(?:0\.\d+)|(?:1(?:\.0{1,2})?))$/, message: '必须为0-1之间的数字', trigger: 'blur' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            sysProfitRatioApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            sysProfitRatioApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
